import { render, staticRenderFns } from "./cotacaoFornecedor.vue?vue&type=template&id=12ee6869"
import script from "./cotacaoFornecedor.ts?vue&type=script&lang=js&external"
export * from "./cotacaoFornecedor.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ee6869')) {
      api.createRecord('12ee6869', component.options)
    } else {
      api.reload('12ee6869', component.options)
    }
    module.hot.accept("./cotacaoFornecedor.vue?vue&type=template&id=12ee6869", function () {
      api.rerender('12ee6869', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/compras/fornecedor/cotacaoFornecedor.vue"
export default component.exports